// Spectator self-registration (132) -- request validation.
import { z } from "zod";

/** POST /me/link-to-school -- manual link: school + the on-file parent email. */
export const linkToSchoolSchema = z.object({
  school_id: z.string().min(1, "School is required"),
  email: z.string().email("A valid email is required"),
});

/** POST /parent-link/confirm -- click-through from the on-file email. */
export const confirmParentLinkSchema = z.object({
  token: z.string().min(1, "token is required"),
});

export type LinkToSchoolInput = z.infer<typeof linkToSchoolSchema>;
export type ConfirmParentLinkInput = z.infer<typeof confirmParentLinkSchema>;
